<template>
<div>
  <VueHtml2pdf
    :show-layout="false"
    :float-layout="true"
    :enable-download="false"
    :preview-modal="false"
    :paginate-elements-by-height="20000"
    filename="hee hee"
    :pdf-quality="2"
    :manual-pagination="false"
    pdf-format="a4"
    pdf-orientation="portrait"
    pdf-content-width="730px"
    @beforeDownload="beforeDownload($event)"
    @hasStartedGeneration="hasStartedGeneration()"
    @hasGenerated="hasGenerated($event)"
    ref="html2Pdf"
    :htmlToPdfOptions="htmlToPdfOptions"
  >
    <section class="actionplan-pdf" slot="pdf-content" style="width:730px"
      id="actionplanPDF"
      v-if="
        satContent &&
          satContent.Tools &&
          currentAssessment &&
          currentAssessment.Id
      "
    >   
        
        <!-- <div class="logo"
          ><img
            src="/images/nspcc-logo.png"
            alt="NSPCC Logo"
        /></div>  --> 
       

        <h1 class="page-title">{{ currentAssessment.Name }}</h1>
        <div class="row">
          <div class="col-12">
            <div
              class="body"
              v-html="currentAssessment.ActionPlanIntroduction"
            ></div>
          </div>
        </div>
        <div class="my-5">
          <h4 class="title">Detailed summary</h4>
          <hr class="solid" />
          <div class="form-row">
            <div class="col-12 col-md-6 col-lg-4">
              <div class="name">Contact name</div>
              <div class="body">
                {{
                  (this.user.FirstName ? this.user.FirstName : "")
                }}
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <div class="name">Created on</div>
              <div class="body">{{ this.savedAssessmentDateCreated }}</div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <div class="name">Last updated</div>
              <div class="body">{{ this.dateUpdated }}</div>
            </div>
          </div>
        </div>  
        
          <div
            class="list-group mb-5"
            v-for="(standard, i) in currentAssessment.Standards"
            :key="standard.Id"
          >
            <ActionPlanPDFStandard :standard="standard" :standardNumber="i + 1" />
          </div>        
      
    </section>
  </VueHtml2pdf>
</div>
  
</template>

<script>
import { mapState, mapActions } from "vuex";
import { GET_SATCONTENTACTION } from "../store/mutation-types";
import { privateRouter } from "../router";
import moment from "moment";
import ActionPlanPDFStandard from "@/components/actionplan-pdf-standard";
import VueHtml2pdf from 'vue-html2pdf'

export default {
  name: "ActionPlanPDF",
  components: {
    ActionPlanPDFStandard,
    VueHtml2pdf
  },
  data() {
    return {
      htmlToPdfOptions: {
        margin: [25, -5, 5, 0],
        html2canvas: {
          scale: 1,
          useCORS: false,
          //x: 565,
          enableLinks: true
          /* width: 700 */
        },
      }
    };
  },
  props: {
    satId: {
      type: Number,
      default: () => 0
    }
  },
  async created() {
    await this.loadSatContent();
  },
  methods: {
    async beforeDownload ({ html2pdf, options, pdfContent }) {
      let today = new Date();
        await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
            const totalPages = pdf.internal.getNumberOfPages()
            for (let i = 1; i <= totalPages; i++) {
                pdf.setPage(i)
                pdf.setFontSize(10)
                pdf.setTextColor(125)
                pdf.text('Page ' + i + ' of ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.87), 10)
                //let img = new Image();
                //img.src = '/assets/images/NSPCC-logo.png';
                //pdf.addImage(img, 'png', 8, 6, 26, 13);
            } 
        }).save(this.currentAssessment.Name + ' Action Plan ' + moment(today).format("DD-MM-YYYY"))
    },
    ...mapActions([GET_SATCONTENTACTION]),
    async loadSatContent() {
      /* if(!this.satContent || !this.satContent.Tools){ // get satContent from API if not in the store (e.g. hitting this route before overview page)
                    await this.getSatContentAction();
                }  */

      // always get satContent from DB for action plan
      await this.getSatContentAction();
    },
    routeToOverview() {
      privateRouter.push({
        name: "SATs",
        query: {
          activeTab: 1
        }
      });
    },
    backToTop() {
      window.scrollTo(0, 0);
    },
    generateReport () {
      console.log('generateReport');
      this.$refs.html2Pdf.generatePdf()
    },    
  },
  computed: {
    ...mapState({
      satContent: state => state.satContent,
      user: state => state.users.user
    }),
    currentAssessment: {
      get() {
        return this.satContent && this.satContent.Tools && this.satId
          ? this.satContent.Tools.filter(tool => {
              return tool.Id === this.satId;
            })[0]
          : {};
      },
      set() {}
    },
    dateUpdated() {
      let savedResponses = [];

      // get saved responses for this assessment
      this.currentAssessment.Standards.forEach(standard => {
        standard.Sections.forEach(section => {
          section.Questions.forEach(question => {
            if(question.SAT_SavedResponses.Id) { // responses sometimes hang around as empty objects after being deleted
              savedResponses.push(question.SAT_SavedResponses); 
            }
          })
        })
      })

      if(savedResponses) {
        savedResponses.sort(function(savedResponses,b){ // sort responses by DateUpdated descending
          return new Date(b.DateUpdated) - new Date(savedResponses.DateUpdated)
        })
        return moment(savedResponses[0].DateUpdated).format("LL") // get last saved response
      } else {
        return "Assessment not saved";
      }
    },
    savedAssessmentDateCreated() {
      return this.currentAssessment.SavedAssessmentDateCreated
        ? moment(this.currentAssessment.SavedAssessmentDateCreated).format("LL")
        : "Assessment not saved";
    }
  }
};
</script>

<style lang="sass" scoped></style>
